export default __webpack_public_path__ + "static/media/First.bce79015.png";